/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ strong: NonNullable<unknown> }} Misc_Posts_Expectlist_Allmovies2Inputs */

const id_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌌 ${i?.strong}: Hidupkan kembali jalan cerita dari sembilan film saga Skywalker, penuh dengan humor LEGO klasik.`)
};

const ms_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌌 ${i?.strong}: Hidupkan semula jalan cerita kesemua sembilan filem saga Skywalker, padat dengan humor LEGO klasik.`)
};

const da_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌌 ${i?.strong}: Genoplev historierne fra alle ni Skywalker-saga-film, fyldt med klassisk LEGO-humor.`)
};

const de_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌌 ${i?.strong}: Erleben Sie die Handlungsstränge aller neun Skywalker-Saga-Filme neu, gefüllt mit klassischem LEGO-Humor.`)
};

const en_us2_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌌 ${i?.strong}: Relive the storylines of all nine Skywalker saga films, packed with classic LEGO humor.`)
};

const es_es2_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌌 ${i?.strong}: Revive las historias de las nueve películas de la saga Skywalker, llenas del clásico humor de LEGO.`)
};

const es_mx2_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌌 ${i?.strong}: Revive las historias de las nueve películas de la saga Skywalker, llenas del clásico humor LEGO.`)
};

const fil_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Buhayin ang mga storyline ng lahat ng siyam na pelikula ng Skywalker saga, puno ng klasikong LEGO humor.`)
};

const fr_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌌 ${i?.strong} : Revivez les intrigues des neuf films de la saga Skywalker, pleines d'humour LEGO classique.`)
};

const it_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Rivivi le storie di tutti e nove i film della saga Skywalker, piene del classico umorismo LEGO.`)
};

const hu_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Éld újra mind a kilenc Skywalker saga film történetét, klasszikus LEGO humorral teli.`)
};

const nl_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Beleef de verhaallijnen van alle negen Skywalker-saga films opnieuw, boordevol klassieke LEGO-humor.`)
};

const no_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Gjenopplev historiene til alle ni Skywalker-saga-filmene, fylt med klassisk LEGO-humor.`)
};

const pl_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌌 ${i?.strong}: Przeżyj historie wszystkich dziewięciu filmów sagi Skywalker, pełne klasycznego humoru LEGO.`)
};

const pt_br2_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌌 ${i?.strong}: Reviva as histórias de todos os nove filmes da saga Skywalker, repletos do humor clássico de LEGO.`)
};

const pt_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌌 ${i?.strong}: Reviva as histórias dos nove filmes da saga Skywalker, repletas do humor clássico LEGO.`)
};

const ro_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌌 ${i?.strong}: Retrăiește poveștile tuturor celor nouă filme ale saga Skywalker, pline de umorul clasic LEGO.`)
};

const fi_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌌 ${i?.strong}: Elä uudelleen kaikkien yhdeksän Skywalker-saagan elokuvan tarinat, täynnä klassista LEGO-huumoria.`)
};

const sv_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌌 ${i?.strong}: Återupplev berättelserna från alla nio Skywalker-sagans filmer, fyllda med klassisk LEGO-humor.`)
};

const vi_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌌 ${i?.strong}: Sống lại cốt truyện của tất cả chín bộ phim saga Skywalker, đầy ắp hài hước LEGO cổ điển.`)
};

const tr_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌌 ${i?.strong}: Klasik LEGO mizahıyla dolu dokuz Skywalker saga filminin hikayelerini yeniden yaşayın.`)
};

const cs_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌌 ${i?.strong}: Prožijte příběhy všech devíti filmů ságy Skywalker, plné klasického LEGO humoru.`)
};

const bg_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌌 ${i?.strong}: Преживейте историите на всичките девет филма от сагата Skywalker, изпълнени с класически LEGO хумор.`)
};

const ru_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌌 ${i?.strong}: Заново переживите сюжеты всех девяти фильмов саги о Скайуокерах, наполненные классическим LEGO-юмором.`)
};

const uk_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌌 ${i?.strong}: Переживіть сюжетні лінії всіх дев'яти фільмів саги Скайвокерів, наповнені класичним гумором LEGO.`)
};

const ar_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌌 ${i?.strong}: عِش قصص أفلام ملحمة Skywalker التسعة، المليئة بفكاهة LEGO الكلاسيكية.`)
};

const hi_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌌 ${i?.strong}: सभी नौ फिल्मों की कहानियों को फिर से जिएँ।`)
};

const th_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌌 ${i?.strong}: สัมผัสเนื้อเรื่องของภาพยนตร์ไตรภาค Skywalker ทั้งเก้าเรื่องอีกครั้ง เต็มไปด้วยอารมณ์ขันสุดคลาสสิกของ LEGO`)
};

const ja_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌌 ${i?.strong}：スカイウォーカー・サーガの全9作品のストーリーを、クラシックな LEGO ユーモアたっぷりに追体験。`)
};

const zh_cn2_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌌 ${i?.strong}：重温全部九部星球大战电影的故事情节，并配有经典的乐高式幽默。`)
};

const zh_hant1_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}：重溫全部九部星際大戰電影的故事情節，並配有經典的樂高式幽默。`)
};

const ko_misc_posts_expectlist_allmovies2 = /** @type {(inputs: Misc_Posts_Expectlist_Allmovies2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: 클래식 LEGO 유머가 담긴 9개의 Skywalker 사가 영화 스토리라인을 재현합니다.`)
};

/**
* | output |
* | --- |
* | "🌌 {strong}: Relive the storylines of all nine Skywalker saga films, packed with classic LEGO humor." |
*
* @param {Misc_Posts_Expectlist_Allmovies2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_expectlist_allmovies2 = /** @type {((inputs: Misc_Posts_Expectlist_Allmovies2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Expectlist_Allmovies2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "ms") return ms_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "da") return da_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "de") return de_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "en-US") return en_us2_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "fil") return fil_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "fr") return fr_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "it") return it_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "hu") return hu_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "nl") return nl_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "no") return no_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "pl") return pl_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "pt") return pt_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "ro") return ro_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "fi") return fi_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "sv") return sv_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "vi") return vi_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "tr") return tr_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "cs") return cs_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "bg") return bg_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "ru") return ru_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "uk") return uk_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "ar") return ar_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "hi") return hi_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "th") return th_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "ja") return ja_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_expectlist_allmovies2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_expectlist_allmovies2(inputs)
	return ko_misc_posts_expectlist_allmovies2(inputs)
});
export { misc_posts_expectlist_allmovies2 as "misc.posts.expectList.allMovies" }